import React from 'react'

import TaskModalsManager from "./modals-task"
import ProjectViewModalsManager from './modals-view'
import DocumentModalsManager from "./modals-document/modals-document"
import ConfirmModalsManager from "./modals-confirm"
import ExportModalsManager from "./export/modals-export"
import Message from "../model2/message/message"
import GoalModalsManager from "./modals-goal"
import ModalClockInOut from "./modal-clock-in-out"
import ModalShareView from "./share-view/share-view"
import ModalsCustomEntity from "./modals-custom-entity"

// @ts-ignore
import ProjectModalsManager from "./modals-project"
// @ts-ignore
import MeetingModalsManager from "./modals-meeting"

import BulkModalsManager from "./modals-bulk"
// @ts-ignore
import CustomViewModalsManager from "./custom-view/modals-custom-view"
// @ts-ignore
import MyTimeModalsManager from "./modals-my-time"
// @ts-ignore
import IntegrationsModalsManager from "./modals-integration"
// @ts-ignore
import OtherModalsManager from "./other/modals-other"
// @ts-ignore
import EventModalsManager from "./modals-event"
// @ts-ignore
import CompanyModalsManager from "./modals-company"
// @ts-ignore
import EditorMentionsManager from "./modals-editor-mentions"
// @ts-ignore
import NewViewTemplateModal from "./new-view-template/new-view-template"
// @ts-ignore
import LoadViewTemplateModal from "./load-view-template/load-view-temlate-modal"
import ModalsCustomField from "./custom-fields/modals-custom-field";
// @ts-ignore
import CRMModalsManager from "./modals-crm"
// @ts-ignore
// import ModalsDependency from "./modals-dependency"
// @ts-ignore
import PortfolioModalsManager from "./portfolio/modals-portfolio"
// @ts-ignore
import RichEditorModalsManager from "./modals-rich-editor"
import ModalsDependency from "./dependency/modals-depenency";
import {PublicSharingType, SharedViewConfig} from "./share-view/@types"
import {ViewType} from "../gd/const/views/view-type";
import TeamsModalsManager from "./modals-users";

export default class ModalsManager {

    public teams                : TeamsModalsManager
    public project              : ProjectModalsManager
    public task                 : TaskModalsManager
    public meeting              : MeetingModalsManager
    public document             : DocumentModalsManager
    public bulk                 : BulkModalsManager
    public confirm              : ConfirmModalsManager
    public customView           : CustomViewModalsManager
    public portfolio            : PortfolioModalsManager
    public myTime               : MyTimeModalsManager
    public integration          : IntegrationsModalsManager
    public other                : OtherModalsManager
    public event                : EventModalsManager
    public company              : CompanyModalsManager
    public mentions             : EditorMentionsManager
    public export               : ExportModalsManager
    public customField          : ModalsCustomField
    public crm                  : CRMModalsManager
    // public dependency           : ModalsDependency
    public richEditor           : RichEditorModalsManager
    public goal                 : GoalModalsManager
    public clockInOut           : ModalClockInOut
    public view                 : ProjectViewModalsManager
    public customEntity         : ModalsCustomEntity
    public dependency           : ModalsDependency

    constructor() {
        this.teams              = new TeamsModalsManager();
        this.project            = new ProjectModalsManager();
        this.task               = new TaskModalsManager();
        this.meeting            = new MeetingModalsManager();
        this.document           = new DocumentModalsManager();
        this.bulk               = new BulkModalsManager();
        this.confirm            = new ConfirmModalsManager();
        this.customView         = new CustomViewModalsManager();
        this.portfolio          = new PortfolioModalsManager()
        this.myTime             = new MyTimeModalsManager();
        this.integration        = new IntegrationsModalsManager();
        this.other              = new OtherModalsManager();
        this.event              = new EventModalsManager();
        this.company            = new CompanyModalsManager();
        this.mentions           = new EditorMentionsManager();
        this.export             = new ExportModalsManager();
        this.customField        = new ModalsCustomField();
        this.crm                = new CRMModalsManager();
        // this.dependency         = new ModalsDependency();
        this.richEditor         = new RichEditorModalsManager();
        this.goal               = new GoalModalsManager()
        this.clockInOut         = new ModalClockInOut()
        this.view               = new ProjectViewModalsManager()
        this.customEntity       = new ModalsCustomEntity()
        this.dependency         = new ModalsDependency()
    }

    oneInput(fieldName:string, currentValue:any, title:string, callback:callback, onToggleCallaback?:callback) {
        gd.modal.showForm({
            className: 'modal-action-edit',
            header: {
                title: title
            },
            component: require('./rename/modal-rename'),
            params: {
                onSubmit: (values:any)=>{
                    if (callback) callback(values.name)
                },
                fieldName, currentValue
            },
            toggleCallback: onToggleCallaback,
        });
    }

    addCustomField(options:any /*{ projectId, taskTypeId, organizationId, newOnly, title }*/, callback?: callback) {
        return this.customField.addCustomField(options, callback)
    }

    createProjectCustomFieldOfType(options :any/*{ projectId, taskTypeId, organizationId, newOnly, title }*/, callback:callback) {
        return this.customField.createProjectCustomFieldOfType(options, callback)
    }

    addProjectStatus({projectId /*string*/, alreadyAddedStatuses, onSubmit /*function on add*/}:any) {
        const project = gd.session.projects.get(projectId);

        gd.modal.showV4({
            className: 'modal-add-status',
            component: require('./add-status/modal-create.jsx'),
            params: {
                onSubmit: onSubmit,
                newOnly: false,
                project: project,
                alreadyAddedStatuses: alreadyAddedStatuses,
                this: this
            }
        });
    }

    editProjectStatus({projectId /*string*/, statusId /*string*/, onSubmit /*function on add*/}:any) {
        const project = gd.session.projects.get(projectId);

        gd.modal.showV4({
            className: 'modal-add-status',
            component: require('./add-status/modal-create.jsx'),
            params: {
                onSubmit: onSubmit,
                newOnly: true,
                project: project,
                statusId: statusId,
                isEditing: true,
            }
        });
    }

    addProjectTasksStatus({
                              projectId /*string*/,
                              alreadyAddedStatuses,
                              onSubmit /*function on add*/
                          }:any) {
        const project = gd.session.projects.get(projectId)!;
        const organization = gd.session.companies.get(project.companyId);

        gd.modal.showV4({
            className: 'modal-add-status',
            component: require('./add-status/modal-create.jsx'),
            params: {
                onSubmit: onSubmit,
                newOnly: false,
                organization: organization,
                alreadyAddedStatuses: alreadyAddedStatuses,
                this: this
            }
        });
    }

    editOrganizationStatus({
                          organizationId /*string*/,
                          statusId /*string*/,
                          onSubmit /*function on add*/
                      }:any) {

        const organization = gd.session.companies.get(organizationId);

        gd.modal.showV4({
            className: 'modal-add-status',
            component: require('./add-status/modal-create.jsx'),
            params: {
                onSubmit: onSubmit,
                newOnly: true,
                organization: organization,
                statusId: statusId,
                isEditing: true,
            }
        });
    }

    // organization projectType and taskType statuses
    addStatus({title /*string*/, organizationId /*number*/, systemStatus /*number*/, alreadyAddedStatuses /*array*/, onSubmit /*func*/}:any) {
        gd.modal.showV4({
            className: 'modal-add-status',
            component: require('./add-status/modal-create.jsx'),
            params: {
                onSubmit: onSubmit,
                newOnly: false,
                organization: gd.session.companies.get(organizationId),
                systemStatus,
                alreadyAddedStatuses
            }
        });
    }

    // organization projectType and taskType statuses
    editStatus({
                   organizationId /*number*/,
                   status /*object*/,
                   systemStatus /*number*/,
                   alreadyAddedStatuses /*array*/,
                   onSubmit /*func*/
    }:any) {
        gd.modal.showV4({
            className: 'modal-add-status',
            component: require('./add-status/modal-create.jsx'),
            params: {
                onSubmit: onSubmit,
                newOnly: true,
                statusId: status.id,
                isEditing: true,
                organization: gd.session.companies.get(organizationId),
                systemStatus,
                alreadyAddedStatuses
            }
        });
    }

    newViewTemplate(name:string, viewSystemType:any, callback:callback) {
        gd.modal.showForm({
            header: {
                title: 'Save View as Template'
            },
            className: 'modal-save-new-template',
            component: NewViewTemplateModal,
            params: {
                name,
                viewSystemType,
                onSubmit: (values:any)=>{
                    gd.modal.hide();
                    if (callback) callback(values);
                }
            }
        });
    }

    editViewTemplate(name:string, access:any, viewSystemType:any, callback:callback) {
        gd.modal.showForm({
            header: {
                title: 'Edit template'
            },
            className: 'modal-save-new-template',
            component: NewViewTemplateModal,
            params: {
                name,
                access,
                viewSystemType,
                isEditTemplate: true,
                onSubmit: (values:any)=>{
                    gd.modal.hide();
                    if (callback) callback(values);
                }
            }
        });
    }

    loadViewTemplate(companyId:ID, systemType:any, callback:callback) {
        gd.modal.showV4({
            className: 'modal-load-view-template',
            component: LoadViewTemplateModal,
            params: {
                companyId,
                systemType,
                onSubmit: (name:string,items:any)=>{
                    if (callback) callback(name,items);
                    gd.modal.hide();
                }
            }
        });
    }

    shareView(sharedViewId:ID|undefined, title:string, type:ViewType, config:SharedViewConfig, sharingType: PublicSharingType, callback:callback) {
        gd.modal.showV4({
            className: 'modal-share-view',
            component: ModalShareView,
            params: {
                sharedViewId,
                title,
                type,
                config,
                sharingType,
                onCallback: (data:any) =>{if (callback) callback(data)}
            }
        });
    }

    newMeetingNote(callback:callback, options : any = {}) {
        gd.modal.showV4({
            className: 'modal-new-meeting-note',
            component: require("./meeting-note/meeting-note"),
            params: {
                title       : "New note",
                showAccess  : _.isNil(options.showAccess) ? true : options.showAccess,
                onCallback  : (data:any)=>{
                    gd.modal.hide();
                    if (callback) callback(data);
                }
            }
        });
    }

    shareMeetingNote(note:any, callback:callback) {
        gd.modal.showV4({
            className: 'modal-share-meeting-note',
            component: require("./meeting-note/meeting-note"),
            params: {
                title: "Share note",
                note,
                onCallback: (data:any) =>{
                    gd.modal.hide();
                    if (callback) callback(data);
                }
            }
        });
    }

    editMessage(message: Message, onSubmit: {(contentText: string, contentRTF: any, attachments: any):void}, onCancel: func) {
        gd.modal.showV4({
            className   : 'modal-edit-message',
            component   : require('./message/modal-edit-message'),
            params      : {
                message     : message,
                onSubmit    : onSubmit,
                onCancel    : onCancel,
            }
        })
    }
}
